import config from "./config";
var axios = config();

export default {
  // get
  getContentById(id) {
    return axios.get("/api/Content/GetContentById/" + id);
  },

  // post
  createContentView(contentId) {
    return axios.post("/api/Content/CreateContentView/" + contentId);
  }
};
